import {
  UserCustomerSupport2X_default
} from "./chunk-RPQJQKA4.mjs";
import {
  UserUsers_default
} from "./chunk-JPI6UFBS.mjs";
import {
  UserUsers2X_default
} from "./chunk-577SHX3R.mjs";
import {
  Users_default
} from "./chunk-B6EQDP47.mjs";
import {
  Users2X_default
} from "./chunk-7MALZ53D.mjs";
import {
  Whatsapp_default
} from "./chunk-FJCXTVOQ.mjs";
import {
  Zap_default
} from "./chunk-6NCLJCFT.mjs";
import {
  ZapOff2X_default
} from "./chunk-ARIM4EVX.mjs";
import {
  Telephone_default
} from "./chunk-IEYJ5XTW.mjs";
import {
  Tool_default
} from "./chunk-S4XSWVB5.mjs";
import {
  ToolSettings_default
} from "./chunk-ZX7NJBTS.mjs";
import {
  ToolSettings2X_default
} from "./chunk-QVK6BC5F.mjs";
import {
  User2X_default
} from "./chunk-P2OLIX2T.mjs";
import {
  UserCheck_default
} from "./chunk-6EURJ7OP.mjs";
import {
  UserCheck2X_default
} from "./chunk-XXSUWRVQ.mjs";
import {
  UserCustomerSupport_default
} from "./chunk-642LTWLO.mjs";
import {
  Stone_default
} from "./chunk-LZT27OCX.mjs";
import {
  StoneAgent_default
} from "./chunk-W46BY5YQ.mjs";
import {
  StoneAgentShakingHands_default
} from "./chunk-SBOI7BFW.mjs";
import {
  StoneAgentShakingHands2X_default
} from "./chunk-AKRUDWCY.mjs";
import {
  StoreShop_default
} from "./chunk-6RCOMEDL.mjs";
import {
  SwapHorizontal_default
} from "./chunk-SBF6KVD2.mjs";
import {
  Tag_default
} from "./chunk-ST6DOJT7.mjs";
import {
  TagLoyalty_default
} from "./chunk-ECYMOYN3.mjs";
import {
  SignalFormStar_default
} from "./chunk-QAND3BVR.mjs";
import {
  SignalLoader_default
} from "./chunk-7TF4CEDE.mjs";
import {
  SignalPercent_default
} from "./chunk-4YSAUOQX.mjs";
import {
  SignalWifi2_default
} from "./chunk-6QJDFYGR.mjs";
import {
  SimCard_default
} from "./chunk-XPYK6W55.mjs";
import {
  Sliders_default
} from "./chunk-UJYDG3WA.mjs";
import {
  SmartPhone_default
} from "./chunk-EQV3WCOP.mjs";
import {
  Star24_default
} from "./chunk-EDPCXXQI.mjs";
import {
  SecurityLock2X_default
} from "./chunk-IDATTALZ.mjs";
import {
  SecurityShield_default
} from "./chunk-IQHXIZCL.mjs";
import {
  SecurityShield2X_default
} from "./chunk-HSJUXUPI.mjs";
import {
  SendMessage_default
} from "./chunk-DMBMBV3J.mjs";
import {
  Share_default
} from "./chunk-HIT7G7QU.mjs";
import {
  Shop2_default
} from "./chunk-ZKM4EJLI.mjs";
import {
  SignalContactless_default
} from "./chunk-QARQXIQK.mjs";
import {
  SignalContactless2X_default
} from "./chunk-TAAM5YNQ.mjs";
import {
  ReceiptList43_default
} from "./chunk-6DD24RUA.mjs";
import {
  ReclameAqui_default
} from "./chunk-YGKFT566.mjs";
import {
  Rings_default
} from "./chunk-D3ZJFFDI.mjs";
import {
  RoundDollar_default
} from "./chunk-ZJ76SM4K.mjs";
import {
  Scan_default
} from "./chunk-B7ZWEZ3Z.mjs";
import {
  SecurityKey_default
} from "./chunk-7OGEUS4Z.mjs";
import {
  SecurityKey2X_default
} from "./chunk-7IRFTRBL.mjs";
import {
  SecurityLock_default
} from "./chunk-S2TR4UUH.mjs";
import {
  Puzzle_default
} from "./chunk-5B27MUDM.mjs";
import {
  QrCode_default
} from "./chunk-M5MAAI6R.mjs";
import {
  QrCode2X_default
} from "./chunk-BM2Y5XHM.mjs";
import {
  QrCodePix_default
} from "./chunk-EPHVOJA5.mjs";
import {
  Question_default
} from "./chunk-7JLTZHHU.mjs";
import {
  RaioX_default
} from "./chunk-USSOEITJ.mjs";
import {
  RateDown_default
} from "./chunk-RJ5FHNQK.mjs";
import {
  RateDown2X_default
} from "./chunk-7REESSM2.mjs";
import {
  Pos_default
} from "./chunk-74C7PZWA.mjs";
import {
  Pos2X_default
} from "./chunk-VPXBZ4XN.mjs";
import {
  PosCoil_default
} from "./chunk-YLLLSBSW.mjs";
import {
  PosQr_default
} from "./chunk-VVNQ2BRY.mjs";
import {
  PosQr2X_default
} from "./chunk-OW6ZNWL4.mjs";
import {
  PosReceiptList2X_default
} from "./chunk-CPC2R6AH.mjs";
import {
  PosSmall_default
} from "./chunk-LBHAD76H.mjs";
import {
  Pounds_default
} from "./chunk-TTULAOM5.mjs";
import {
  PhoneSmart2X_default
} from "./chunk-CN3K4EHB.mjs";
import {
  Pig_default
} from "./chunk-S6P4IOPF.mjs";
import {
  Pill_default
} from "./chunk-ZJX7K4FH.mjs";
import {
  Pix_default
} from "./chunk-UIEDKSQY.mjs";
import {
  Play_default
} from "./chunk-ZFBOQ3OE.mjs";
import {
  PlayBorder_default
} from "./chunk-MYQ7DJWJ.mjs";
import {
  Plus_default
} from "./chunk-PPGTE2VH.mjs";
import {
  PlusCircle_default
} from "./chunk-RVX5MBUE.mjs";
import {
  Phone2X_default
} from "./chunk-5BDNF736.mjs";
import {
  PhoneCard_default
} from "./chunk-UIRI2P4C.mjs";
import {
  PhoneCard2X_default
} from "./chunk-RESC5Y4T.mjs";
import {
  PhoneChat_default
} from "./chunk-J6AJMVOE.mjs";
import {
  PhoneChat2X_default
} from "./chunk-N4LRGO5C.mjs";
import {
  PhoneCheck_default
} from "./chunk-FNUDH3AG.mjs";
import {
  PhoneMobile_default
} from "./chunk-JSUWCS3J.mjs";
import {
  PhoneOutgoing_default
} from "./chunk-GXFFRPFN.mjs";
import {
  OneStars_default
} from "./chunk-J46YBTJS.mjs";
import {
  OpenBook_default
} from "./chunk-FOC7RZJE.mjs";
import {
  PapoDeBalcao_default
} from "./chunk-JQI2AHNP.mjs";
import {
  Pause_default
} from "./chunk-ZYCO37RM.mjs";
import {
  PaymentLink_default
} from "./chunk-PHWVZL7C.mjs";
import {
  PeopleHandshake_default
} from "./chunk-GBNDA2A2.mjs";
import {
  PeopleQuestion_default
} from "./chunk-VVK3AU2A.mjs";
import {
  Phone_default
} from "./chunk-XSALMAR2.mjs";
import {
  Money2X_default
} from "./chunk-VYWPFQUT.mjs";
import {
  MoneyGrowth_default
} from "./chunk-RZQATCPI.mjs";
import {
  MoneyHand_default
} from "./chunk-XYOY5ACG.mjs";
import {
  MoneyHand24_default
} from "./chunk-CUZSV7BR.mjs";
import {
  MoneyHand2X_default
} from "./chunk-2YCSOQBN.mjs";
import {
  MoneyTime_default
} from "./chunk-RBQ3MRJO.mjs";
import {
  Office_default
} from "./chunk-YD27TQSJ.mjs";
import {
  Office2X_default
} from "./chunk-BAJ65V26.mjs";
import {
  Message_default
} from "./chunk-UBCQV6QS.mjs";
import {
  Message2X_default
} from "./chunk-EMPMV6VZ.mjs";
import {
  Minus_default
} from "./chunk-OTOL2RFX.mjs";
import {
  MinusCircle_default
} from "./chunk-RF645RCU.mjs";
import {
  MobileBanking_default
} from "./chunk-SMGY6FVC.mjs";
import {
  MobileCard_default
} from "./chunk-P2HJWJTU.mjs";
import {
  MobilePhone_default
} from "./chunk-YNPUHVGT.mjs";
import {
  Money_default
} from "./chunk-UN4UMPM3.mjs";
import {
  LogoStone2X_default
} from "./chunk-ZXP2LRRW.mjs";
import {
  LogoTon_default
} from "./chunk-PI3GPTO2.mjs";
import {
  LogoTonStone_default
} from "./chunk-4QNYYFEE.mjs";
import {
  LogoWhatsapp_default
} from "./chunk-HLGSZDLU.mjs";
import {
  LogoWhatsapp2X_default
} from "./chunk-TTSPRQLX.mjs";
import {
  LoyaltyHeart2X_default
} from "./chunk-BZ6W5YDZ.mjs";
import {
  Machine_default
} from "./chunk-X5RPLJYG.mjs";
import {
  Mail_default
} from "./chunk-6DL4PTSC.mjs";
import {
  LifeBuoy_default
} from "./chunk-QSKY46OQ.mjs";
import {
  Link_default
} from "./chunk-3X7YPBSL.mjs";
import {
  Link2X_default
} from "./chunk-LI3NNGDT.mjs";
import {
  Lock_default
} from "./chunk-3EBLZS2F.mjs";
import {
  Logo_default
} from "./chunk-WDXLGAED.mjs";
import {
  LogoRaioX_default
} from "./chunk-OUB5ZKJM.mjs";
import {
  LogoRaioX2X_default
} from "./chunk-PJQQSAEX.mjs";
import {
  LogoStone_default
} from "./chunk-4WJIE2IA.mjs";
import {
  HelpInfo_default
} from "./chunk-LOF3HVR4.mjs";
import {
  HelpInfo2X_default
} from "./chunk-M7D2WUI5.mjs";
import {
  Hospital_default
} from "./chunk-SAQIYMH5.mjs";
import {
  Hospital2X_default
} from "./chunk-VLHWEYLK.mjs";
import {
  Info_default
} from "./chunk-WMCHM7PU.mjs";
import {
  Invoice2_default
} from "./chunk-MOMIQISU.mjs";
import {
  Invoice22X_default
} from "./chunk-NJS3FYPB.mjs";
import {
  Libras_default
} from "./chunk-4UPITOGO.mjs";
import {
  HandShake_default
} from "./chunk-NAT2JBXR.mjs";
import {
  HandShake2X_default
} from "./chunk-OTSJELLP.mjs";
import {
  HandshakeSoft_default
} from "./chunk-AGOOQ2SQ.mjs";
import {
  HeadPhone_default
} from "./chunk-VJWULD6F.mjs";
import {
  Headset_default
} from "./chunk-42VGIAOJ.mjs";
import {
  HealthFaceHappy_default
} from "./chunk-ADY4FGZ6.mjs";
import {
  Heart_default
} from "./chunk-ODO2ZITN.mjs";
import {
  Heart24_default
} from "./chunk-B4ZNI4MU.mjs";
import {
  Gift_default
} from "./chunk-SEJAEZNA.mjs";
import {
  Global_default
} from "./chunk-XUG5UNP7.mjs";
import {
  Grid_default
} from "./chunk-55X5UYXT.mjs";
import {
  Grid2_default
} from "./chunk-LGRMSD3D.mjs";
import {
  HandHeart_default
} from "./chunk-QHY4AEVZ.mjs";
import {
  HandHeart2X_default
} from "./chunk-FHZKTYGK.mjs";
import {
  HandHeartSoft_default
} from "./chunk-TNPH7E6R.mjs";
import {
  HandMoney_default
} from "./chunk-WWZMF33J.mjs";
import {
  File2X_default
} from "./chunk-YTJC64AV.mjs";
import {
  FileTyped_default
} from "./chunk-SPI53RGN.mjs";
import {
  FinanceAndStone_default
} from "./chunk-5EERA3MX.mjs";
import {
  FlipUp_default
} from "./chunk-DILPFG6I.mjs";
import {
  FlipUp2_default
} from "./chunk-F6UXLZOS.mjs";
import {
  FormHeart2X_default
} from "./chunk-OJM7CFIS.mjs";
import {
  FormStar_default
} from "./chunk-ABK4WFZS.mjs";
import {
  FormStar2X_default
} from "./chunk-GGVWAL53.mjs";
import {
  ECommerce_default
} from "./chunk-HY5E2AI2.mjs";
import {
  Ecommerce2X_default
} from "./chunk-M2WCP2XC.mjs";
import {
  EconomicoValor_default
} from "./chunk-2UOA7VR4.mjs";
import {
  Email_default
} from "./chunk-5O7V6QVD.mjs";
import {
  Email2X_default
} from "./chunk-AVNKU2ST.mjs";
import {
  FaceHappy_default
} from "./chunk-RXHYCOVK.mjs";
import {
  FaceHappy2X_default
} from "./chunk-CVPJRYXZ.mjs";
import {
  File_default
} from "./chunk-GTIASALZ.mjs";
import {
  DollarPhone2X_default
} from "./chunk-F7GIIKQR.mjs";
import {
  DollarShield_default
} from "./chunk-DCEXTVOV.mjs";
import {
  DollarShield2X_default
} from "./chunk-AUWBYHKJ.mjs";
import {
  DollarSign_default
} from "./chunk-3JD4EM74.mjs";
import {
  DollarSign2X_default
} from "./chunk-NXE36QQ5.mjs";
import {
  DuoStars_default
} from "./chunk-KOKTX424.mjs";
import {
  ECart_default
} from "./chunk-ZHWYI2HE.mjs";
import {
  ECart2X_default
} from "./chunk-O6UWALVL.mjs";
import {
  DollarCircle_default
} from "./chunk-3S7FIIRJ.mjs";
import {
  DollarInvoicePay_default
} from "./chunk-MM73NGN5.mjs";
import {
  DollarInvoicePay2X_default
} from "./chunk-PXUH5IS6.mjs";
import {
  DollarOff_default
} from "./chunk-DDVYD7WU.mjs";
import {
  DollarOff2X_default
} from "./chunk-KGOZVLCR.mjs";
import {
  DollarPaymentLink_default
} from "./chunk-TAV3G66Z.mjs";
import {
  DollarPaymentLink2X_default
} from "./chunk-KP73ZQDN.mjs";
import {
  DollarPhone_default
} from "./chunk-KSOTUBWF.mjs";
import {
  CreditCard_default
} from "./chunk-V2VOGXFX.mjs";
import {
  CustomerSupport_default
} from "./chunk-KWB3ORNK.mjs";
import {
  CustomerSupport2X_default
} from "./chunk-VWKMPL2C.mjs";
import {
  Cutlery_default
} from "./chunk-CKS6BEJL.mjs";
import {
  DateCalendar_default
} from "./chunk-G7PMWQCE.mjs";
import {
  DateCalendar2X_default
} from "./chunk-YNJJLIDP.mjs";
import {
  DateClock_default
} from "./chunk-QIRX4RAW.mjs";
import {
  DateClock2X_default
} from "./chunk-45RZ7C5C.mjs";
import {
  Clock24_default
} from "./chunk-A7WL3NQA.mjs";
import {
  Close_default
} from "./chunk-7BDTA2WW.mjs";
import {
  CloseRound_default
} from "./chunk-5RRBDX5N.mjs";
import {
  Cnn_default
} from "./chunk-IDIC2BRZ.mjs";
import {
  Coil_default
} from "./chunk-CNEAI33K.mjs";
import {
  Contactless_default
} from "./chunk-WKFRPVA7.mjs";
import {
  ContactlessCard_default
} from "./chunk-OZQFOWM4.mjs";
import {
  Coupon_default
} from "./chunk-BDN5XLNT.mjs";
import {
  CheckPhone_default
} from "./chunk-MBUD7EWB.mjs";
import {
  CheckRound_default
} from "./chunk-4SEYIINI.mjs";
import {
  ChevronDown_default
} from "./chunk-YUMHPO7E.mjs";
import {
  ChevronLeft_default
} from "./chunk-A2ON3OYH.mjs";
import {
  ChevronRight_default
} from "./chunk-JDXPIJVW.mjs";
import {
  ChevronRight2X_default
} from "./chunk-UQ6QHP3G.mjs";
import {
  ChevronUp_default
} from "./chunk-7J53QEEF.mjs";
import {
  Clock_default
} from "./chunk-LV2B6LER.mjs";
import {
  ChartBar2_default
} from "./chunk-2TBOVZO2.mjs";
import {
  ChartBar22X_default
} from "./chunk-NGSR7PTC.mjs";
import {
  ChartBar3_default
} from "./chunk-2ANOB3D7.mjs";
import {
  ChartSmall_default
} from "./chunk-67N5BHBY.mjs";
import {
  ChartSmall2X_default
} from "./chunk-FSV5HXXA.mjs";
import {
  Check_default
} from "./chunk-Y2B4OB4H.mjs";
import {
  Check2X_default
} from "./chunk-6ALHTV6P.mjs";
import {
  CheckCircle_default
} from "./chunk-5BO2HB2F.mjs";
import {
  CardStone_default
} from "./chunk-BVIEJJQQ.mjs";
import {
  CardStone2X_default
} from "./chunk-ECFD5LO5.mjs";
import {
  Cart_default
} from "./chunk-F77XIOWQ.mjs";
import {
  CashPhone_default
} from "./chunk-ANIOF26G.mjs";
import {
  CashRound_default
} from "./chunk-UOOCQURS.mjs";
import {
  CentClock_default
} from "./chunk-Y37UV5MF.mjs";
import {
  CentClock2X_default
} from "./chunk-2MPVWBHS.mjs";
import {
  CentHand2X_default
} from "./chunk-OXDI4AAV.mjs";
import {
  Calculator2X_default
} from "./chunk-LOLGLUBL.mjs";
import {
  Calendar_default
} from "./chunk-H5MVJXDZ.mjs";
import {
  CardCredit_default
} from "./chunk-HDLNABEQ.mjs";
import {
  CardCredit2X_default
} from "./chunk-S2PF3L3X.mjs";
import {
  CardHand_default
} from "./chunk-LSPSIDCQ.mjs";
import {
  CardHand2X_default
} from "./chunk-FLT66YCP.mjs";
import {
  CardIn_default
} from "./chunk-L2GBEETS.mjs";
import {
  CardIn2X_default
} from "./chunk-54PBQWYT.mjs";
import {
  Bank_default
} from "./chunk-UBIULXV6.mjs";
import {
  Bank2X_default
} from "./chunk-KAZGYSLF.mjs";
import {
  BatteryCharging_default
} from "./chunk-3RYA4LHV.mjs";
import {
  BlackQrCode_default
} from "./chunk-JZJFFNQQ.mjs";
import {
  BookOpen_default
} from "./chunk-RLUGIYJO.mjs";
import {
  BookOpen2X_default
} from "./chunk-BBWKZMWY.mjs";
import {
  BoxGift_default
} from "./chunk-YCWCCWBK.mjs";
import {
  Calculator_default
} from "./chunk-OGYIPGUA.mjs";
import {
  ArrowUp_default
} from "./chunk-2473A4MG.mjs";
import {
  ArrowUpRight_default
} from "./chunk-XNFCEXFR.mjs";
import {
  AudioVideoPlayCircle_default
} from "./chunk-2ZOQL6C2.mjs";
import {
  AutoBus_default
} from "./chunk-I4ACIPQK.mjs";
import {
  AutoBus2X_default
} from "./chunk-A2QCEK27.mjs";
import {
  AutoTruck_default
} from "./chunk-QJYXMO4L.mjs";
import {
  Award_default
} from "./chunk-NL64XYIL.mjs";
import {
  BChartSmall_default
} from "./chunk-ETU7PWIY.mjs";
import {
  ArrowDown2X_default
} from "./chunk-5Q2JOQXI.mjs";
import {
  ArrowFillLeft_default
} from "./chunk-B63LTNTD.mjs";
import {
  ArrowLeft_default
} from "./chunk-WNFVLKWB.mjs";
import {
  ArrowLeft2X_default
} from "./chunk-UITWOMOK.mjs";
import {
  ArrowRight_default
} from "./chunk-LPDLEHDO.mjs";
import {
  ArrowRight2X_default
} from "./chunk-UPZJHVHI.mjs";
import {
  ArrowSwapHorizontal_default
} from "./chunk-XEBALTZM.mjs";
import {
  ArrowSwapHorizontal2X_default
} from "./chunk-N2ERDOFO.mjs";
import {
  Accelerator_default
} from "./chunk-IRW4CJMF.mjs";
import {
  Accelerator2X_default
} from "./chunk-5BLWAKR7.mjs";
import {
  AgentStone_default
} from "./chunk-FCH5OXCK.mjs";
import {
  Apps_default
} from "./chunk-2XMFVC76.mjs";
import {
  Apps2X_default
} from "./chunk-VBYXVEZY.mjs";
import {
  ArrowDown_default
} from "./chunk-2IKCXRYW.mjs";
import {
  __export
} from "./chunk-7P6ASYW6.mjs";

// src/stone/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  accelerator: () => Accelerator_default,
  accelerator2X: () => Accelerator2X_default,
  agentStone: () => AgentStone_default,
  apps: () => Apps_default,
  apps2X: () => Apps2X_default,
  arrowDown: () => ArrowDown_default,
  arrowDown2X: () => ArrowDown2X_default,
  arrowFillLeft: () => ArrowFillLeft_default,
  arrowLeft: () => ArrowLeft_default,
  arrowLeft2X: () => ArrowLeft2X_default,
  arrowRight: () => ArrowRight_default,
  arrowRight2X: () => ArrowRight2X_default,
  arrowSwapHorizontal: () => ArrowSwapHorizontal_default,
  arrowSwapHorizontal2X: () => ArrowSwapHorizontal2X_default,
  arrowUp: () => ArrowUp_default,
  arrowUpRight: () => ArrowUpRight_default,
  audioVideoPlayCircle: () => AudioVideoPlayCircle_default,
  autoBus: () => AutoBus_default,
  autoBus2X: () => AutoBus2X_default,
  autoTruck: () => AutoTruck_default,
  award: () => Award_default,
  bChartSmall: () => BChartSmall_default,
  bank: () => Bank_default,
  bank2X: () => Bank2X_default,
  batteryCharging: () => BatteryCharging_default,
  blackQrCode: () => BlackQrCode_default,
  bookOpen: () => BookOpen_default,
  bookOpen2X: () => BookOpen2X_default,
  boxGift: () => BoxGift_default,
  calculator: () => Calculator_default,
  calculator2X: () => Calculator2X_default,
  calendar: () => Calendar_default,
  cardCredit: () => CardCredit_default,
  cardCredit2X: () => CardCredit2X_default,
  cardHand: () => CardHand_default,
  cardHand2X: () => CardHand2X_default,
  cardIn: () => CardIn_default,
  cardIn2X: () => CardIn2X_default,
  cardStone: () => CardStone_default,
  cardStone2X: () => CardStone2X_default,
  cart: () => Cart_default,
  cashPhone: () => CashPhone_default,
  cashRound: () => CashRound_default,
  centClock: () => CentClock_default,
  centClock2X: () => CentClock2X_default,
  centHand2X: () => CentHand2X_default,
  chartBar2: () => ChartBar2_default,
  chartBar22X: () => ChartBar22X_default,
  chartBar3: () => ChartBar3_default,
  chartSmall: () => ChartSmall_default,
  chartSmall2X: () => ChartSmall2X_default,
  check: () => Check_default,
  check2X: () => Check2X_default,
  checkCircle: () => CheckCircle_default,
  checkPhone: () => CheckPhone_default,
  checkRound: () => CheckRound_default,
  chevronDown: () => ChevronDown_default,
  chevronLeft: () => ChevronLeft_default,
  chevronRight: () => ChevronRight_default,
  chevronRight2X: () => ChevronRight2X_default,
  chevronUp: () => ChevronUp_default,
  clock: () => Clock_default,
  clock24: () => Clock24_default,
  close: () => Close_default,
  closeRound: () => CloseRound_default,
  cnn: () => Cnn_default,
  coil: () => Coil_default,
  contactless: () => Contactless_default,
  contactlessCard: () => ContactlessCard_default,
  coupon: () => Coupon_default,
  creditCard: () => CreditCard_default,
  customerSupport: () => CustomerSupport_default,
  customerSupport2X: () => CustomerSupport2X_default,
  cutlery: () => Cutlery_default,
  dateCalendar: () => DateCalendar_default,
  dateCalendar2X: () => DateCalendar2X_default,
  dateClock: () => DateClock_default,
  dateClock2X: () => DateClock2X_default,
  dollarCircle: () => DollarCircle_default,
  dollarInvoicePay: () => DollarInvoicePay_default,
  dollarInvoicePay2X: () => DollarInvoicePay2X_default,
  dollarOff: () => DollarOff_default,
  dollarOff2X: () => DollarOff2X_default,
  dollarPaymentLink: () => DollarPaymentLink_default,
  dollarPaymentLink2X: () => DollarPaymentLink2X_default,
  dollarPhone: () => DollarPhone_default,
  dollarPhone2X: () => DollarPhone2X_default,
  dollarShield: () => DollarShield_default,
  dollarShield2X: () => DollarShield2X_default,
  dollarSign: () => DollarSign_default,
  dollarSign2X: () => DollarSign2X_default,
  duoStars: () => DuoStars_default,
  eCart: () => ECart_default,
  eCart2X: () => ECart2X_default,
  eCommerce: () => ECommerce_default,
  ecommerce2X: () => Ecommerce2X_default,
  economicoValor: () => EconomicoValor_default,
  email: () => Email_default,
  email2X: () => Email2X_default,
  faceHappy: () => FaceHappy_default,
  faceHappy2X: () => FaceHappy2X_default,
  file: () => File_default,
  file2X: () => File2X_default,
  fileTyped: () => FileTyped_default,
  financeAndStone: () => FinanceAndStone_default,
  flipUp: () => FlipUp_default,
  flipUp2: () => FlipUp2_default,
  formHeart2X: () => FormHeart2X_default,
  formStar: () => FormStar_default,
  formStar2X: () => FormStar2X_default,
  gift: () => Gift_default,
  global: () => Global_default,
  grid: () => Grid_default,
  grid2: () => Grid2_default,
  handHeart: () => HandHeart_default,
  handHeart2X: () => HandHeart2X_default,
  handHeartSoft: () => HandHeartSoft_default,
  handMoney: () => HandMoney_default,
  handShake: () => HandShake_default,
  handShake2X: () => HandShake2X_default,
  handshakeSoft: () => HandshakeSoft_default,
  headPhone: () => HeadPhone_default,
  headset: () => Headset_default,
  healthFaceHappy: () => HealthFaceHappy_default,
  heart: () => Heart_default,
  heart24: () => Heart24_default,
  helpInfo: () => HelpInfo_default,
  helpInfo2X: () => HelpInfo2X_default,
  hospital: () => Hospital_default,
  hospital2X: () => Hospital2X_default,
  info: () => Info_default,
  invoice2: () => Invoice2_default,
  invoice22X: () => Invoice22X_default,
  libras: () => Libras_default,
  lifeBuoy: () => LifeBuoy_default,
  link: () => Link_default,
  link2X: () => Link2X_default,
  lock: () => Lock_default,
  logo: () => Logo_default,
  logoRaioX: () => LogoRaioX_default,
  logoRaioX2X: () => LogoRaioX2X_default,
  logoStone: () => LogoStone_default,
  logoStone2X: () => LogoStone2X_default,
  logoTon: () => LogoTon_default,
  logoTonStone: () => LogoTonStone_default,
  logoWhatsapp: () => LogoWhatsapp_default,
  logoWhatsapp2X: () => LogoWhatsapp2X_default,
  loyaltyHeart2X: () => LoyaltyHeart2X_default,
  machine: () => Machine_default,
  mail: () => Mail_default,
  message: () => Message_default,
  message2X: () => Message2X_default,
  minus: () => Minus_default,
  minusCircle: () => MinusCircle_default,
  mobileBanking: () => MobileBanking_default,
  mobileCard: () => MobileCard_default,
  mobilePhone: () => MobilePhone_default,
  money: () => Money_default,
  money2X: () => Money2X_default,
  moneyGrowth: () => MoneyGrowth_default,
  moneyHand: () => MoneyHand_default,
  moneyHand24: () => MoneyHand24_default,
  moneyHand2X: () => MoneyHand2X_default,
  moneyTime: () => MoneyTime_default,
  office: () => Office_default,
  office2X: () => Office2X_default,
  oneStars: () => OneStars_default,
  openBook: () => OpenBook_default,
  papoDeBalcao: () => PapoDeBalcao_default,
  pause: () => Pause_default,
  paymentLink: () => PaymentLink_default,
  peopleHandshake: () => PeopleHandshake_default,
  peopleQuestion: () => PeopleQuestion_default,
  phone: () => Phone_default,
  phone2X: () => Phone2X_default,
  phoneCard: () => PhoneCard_default,
  phoneCard2X: () => PhoneCard2X_default,
  phoneChat: () => PhoneChat_default,
  phoneChat2X: () => PhoneChat2X_default,
  phoneCheck: () => PhoneCheck_default,
  phoneMobile: () => PhoneMobile_default,
  phoneOutgoing: () => PhoneOutgoing_default,
  phoneSmart2X: () => PhoneSmart2X_default,
  pig: () => Pig_default,
  pill: () => Pill_default,
  pix: () => Pix_default,
  play: () => Play_default,
  playBorder: () => PlayBorder_default,
  plus: () => Plus_default,
  plusCircle: () => PlusCircle_default,
  pos: () => Pos_default,
  pos2X: () => Pos2X_default,
  posCoil: () => PosCoil_default,
  posQr: () => PosQr_default,
  posQr2X: () => PosQr2X_default,
  posReceiptList2X: () => PosReceiptList2X_default,
  posSmall: () => PosSmall_default,
  pounds: () => Pounds_default,
  puzzle: () => Puzzle_default,
  qrCode: () => QrCode_default,
  qrCode2X: () => QrCode2X_default,
  qrCodePix: () => QrCodePix_default,
  question: () => Question_default,
  raioX: () => RaioX_default,
  rateDown: () => RateDown_default,
  rateDown2X: () => RateDown2X_default,
  receiptList43: () => ReceiptList43_default,
  reclameAqui: () => ReclameAqui_default,
  rings: () => Rings_default,
  roundDollar: () => RoundDollar_default,
  scan: () => Scan_default,
  securityKey: () => SecurityKey_default,
  securityKey2X: () => SecurityKey2X_default,
  securityLock: () => SecurityLock_default,
  securityLock2X: () => SecurityLock2X_default,
  securityShield: () => SecurityShield_default,
  securityShield2X: () => SecurityShield2X_default,
  sendMessage: () => SendMessage_default,
  share: () => Share_default,
  shop2: () => Shop2_default,
  signalContactless: () => SignalContactless_default,
  signalContactless2X: () => SignalContactless2X_default,
  signalFormStar: () => SignalFormStar_default,
  signalLoader: () => SignalLoader_default,
  signalPercent: () => SignalPercent_default,
  signalWifi2: () => SignalWifi2_default,
  simCard: () => SimCard_default,
  sliders: () => Sliders_default,
  smartPhone: () => SmartPhone_default,
  star24: () => Star24_default,
  stone: () => Stone_default,
  stoneAgent: () => StoneAgent_default,
  stoneAgentShakingHands: () => StoneAgentShakingHands_default,
  stoneAgentShakingHands2X: () => StoneAgentShakingHands2X_default,
  storeShop: () => StoreShop_default,
  swapHorizontal: () => SwapHorizontal_default,
  tag: () => Tag_default,
  tagLoyalty: () => TagLoyalty_default,
  telephone: () => Telephone_default,
  tool: () => Tool_default,
  toolSettings: () => ToolSettings_default,
  toolSettings2X: () => ToolSettings2X_default,
  user2X: () => User2X_default,
  userCheck: () => UserCheck_default,
  userCheck2X: () => UserCheck2X_default,
  userCustomerSupport: () => UserCustomerSupport_default,
  userCustomerSupport2X: () => UserCustomerSupport2X_default,
  userUsers: () => UserUsers_default,
  userUsers2X: () => UserUsers2X_default,
  users: () => Users_default,
  users2X: () => Users2X_default,
  whatsapp: () => Whatsapp_default,
  zap: () => Zap_default,
  zapOff2X: () => ZapOff2X_default
});

export {
  icons_exports
};
